import { getReturnCarOrderList } from '@/api/domain/returnLease'
import {
  RETURN_CAR_ORDER_STATES,
  RETURN_CAR_TYPES,
  ORDER_TYPES,
} from '@/pages/cars/returnCar/config'
import { operateMaxShowLength } from '@/store/dict/config'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'
// 批量还车模版
export const BATCH_UPLOAD_TEMPLATE_URL =
  'https://server-resource-testv2.cheweijia.com/public/common_for_test_file/4d9ed8f15a974035908dbaa346a277e2/%E6%89%B9%E9%87%8F%E5%8F%91%E8%B5%B7%E9%80%80%E8%BD%A6%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'

// 个人还车新建（编辑）页
const PERSONAL_ADD_PATH = '/returnLease/returnCar/personalAdd'
// 个人还车详情页
const PERSONAL_DETAIL_PATH = '/returnLease/returnCar/personalDetail'
// 企业还车新建（编辑）页
const ENTERPRISE_ADD_PATH = '/returnLease/returnCar/enterpriseAdd'
// 企业还车详情页
const ENTERPRISE_DETAIL_PATH = '/returnLease/returnCar/enterpriseDetail'

export const LINK_CONFIG = {
  [ORDER_TYPES.personal.name]: {
    orderType: 'personal',
    path: '/workbench/rentOrder/detail',
  },
  [ORDER_TYPES.enterprise.name]: {
    path: '/workbench/entOrder/detail/child',
  },
}

// 退车单状态统计列表
export const TAB_LIST = [
  {
    label: '全部',
    key: 'allNum',
    name: '0',
    value: 0,
  },
  {
    label: '已预约',
    key: 'bookFinishNum',
    name: '50',
    value: 0,
  },
  {
    label: '待验车',
    key: 'toInspectNum',
    name: '100',
    value: 0,
  },
  {
    label: '待核算',
    key: 'toAccountNum',
    name: '200',
    value: 0,
  },
  {
    label: '待结算',
    key: 'toSettleNum',
    name: '300',
    value: 0,
  },
  {
    label: '已完成',
    key: 'completedNum',
    name: '400',
    value: 0,
  },
  {
    label: '已关闭',
    key: 'closedNum',
    name: '500',
    value: 0,
  },
]

export const mixin = {
  data() {
    const { $router } = this
    return {
      configData: {
        formData: {
          list: [
            {
              el: 'input',
              itemConfig: {
                label: '退车单ID',
                prop: 'id',
              },
              directives: [{ name: 'number', arg: 'integer', value: 18 }],
              elConfig: {
                placeholder: '请输入退车单ID',
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '车牌号',
                prop: 'carId',
              },
              elConfig: {
                filterable: true,
                remote: true,
                reserveKeyword: true,
                clearable: true,
                defaultFirstOption: true,
                remoteMethod: this.gerCarList,
                loading: this.carIdSearchLoading,
                placeholder: '请输入',
                options: {
                  label: 'plateNo',
                  value: 'id',
                  list: [],
                },
              },
            },
            {
              itemConfig: {
                prop: 'brandSeriesModel',
              },
              elConfig: {
                showModel: true,
                filterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
              },
              render: 'CarBrandSeriesModel',
            },
            {
              el: 'select',
              itemConfig: {
                label: '客户名称',
                prop: 'customerId',
              },
              elConfig: {
                jsxRender: (option) => {
                  return <CustomerNameOptionItem data={option} />
                },
                filterable: true,
                remote: true,
                reserveKeyword: true,
                clearable: true,
                defaultFirstOption: true,
                remoteMethod: this.getCustomerList,
                loading: this.customerIdSearchLoading,
                placeholder: '请输入',
                options: {
                  label: 'customerName',
                  value: 'id',
                  list: [],
                },
              },
            },
            {
              el: 'input',
              itemConfig: {
                label: '订单ID',
                prop: 'orderId',
              },
              directives: [{ name: 'number', arg: 'integer', value: 18 }],
              elConfig: {
                placeholder: '请输入订单ID',
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '订单类型',
                prop: 'orderType',
              },
              elConfig: {
                placeholder: '请选择订单类型',
                options: {
                  label: 'name',
                  value: 'value',
                  list: Object.values(ORDER_TYPES),
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '退车类型',
                prop: 'returnType',
              },
              elConfig: {
                placeholder: '请选择退车类型',
                options: {
                  label: 'name',
                  value: 'value',
                  list: Object.values(RETURN_CAR_TYPES),
                },
              },
            },
            {
              el: 'date-picker',
              itemConfig: {
                label: '预约退车时间',
                prop: 'bookTime',
              },
              elConfig: {
                clearable: true,
                type: 'datetimerange',
                'range-separator': '至',
                'start-placeholder': '开始日期',
                'end-placeholder': '结束日期',
                format: 'yyyy-MM-dd HH:mm:ss',
              },
            },
            {
              el: 'date-picker',
              itemConfig: {
                label: '退车发起时间',
                prop: 'returnTime',
              },
            },
          ],
          exportData: {
            exportTemplate: 'ReturnCarOrderList',
            filename: '客户还车.xlsx',
            permissionName: 'return_lease_export',
          },
          dealWithSearch: this.dealWithSearch,
          customizeReset: () => {
            this.$refs.baseListManagement.setItemData({
              elConfigKey: 'value',
              key: 'brandSeriesModel',
              data: {},
            })
          },
        },
        tableData: {
          columns: [
            {
              name: 'id',
              columnProps: {
                label: '退车单ID',
                prop: 'id',
                width: 120,
              },
              render: ({ row }) => {
                const { id, orderId, orderType } = row
                const detailBtnAction = () => {
                  const queryObj = {
                    id,
                    orderId,
                  }
                  const queryStr = encodeURIComponent(JSON.stringify(queryObj))
                  const pathStr =
                    orderType === ORDER_TYPES.personal.name
                      ? PERSONAL_DETAIL_PATH
                      : ENTERPRISE_DETAIL_PATH
                  $router.push(`${pathStr}?query=${queryStr}`)
                }
                return (
                  <span class="a-hover-link" onClick={() => detailBtnAction()}>
                    {id}
                  </span>
                )
              },
            },
            {
              name: 'platoNo',
              columnProps: {
                label: '车牌号',
                prop: 'platoNo',
                width: 100,
              },
            },
            {
              name: 'brandName',
              columnProps: {
                label: '品牌',
                prop: 'brandName',
              },
            },
            {
              name: 'seriesName',
              columnProps: {
                label: '车系',
                prop: 'seriesName',
              },
            },
            {
              name: 'modelName',
              columnProps: {
                label: '车型',
                prop: 'modelName',
                width: 160,
              },
              showEllipsisTooltip: true,
              limitEllipsisLine: 1,
            },
            {
              name: 'customerName',
              columnProps: {
                label: '客户名称',
                prop: 'customerName',
                width: 110,
              },
              showEllipsisTooltip: true,
              limitEllipsisLine: 1,
            },
            {
              name: 'orderId',
              columnProps: {
                label: '订单ID',
                prop: 'orderId',
              },
              render: ({ row }) => {
                const { orderId } = row
                const detailBtnAction = () => {
                  const { orderType, path } = LINK_CONFIG[row.orderType]
                  $router.push({
                    path,
                    query: {
                      id: orderId,
                      orderType,
                    },
                  })
                }
                return (
                  <span class="a-hover-link" onClick={() => detailBtnAction()}>
                    {orderId}
                  </span>
                )
              },
            },
            {
              name: 'orderType',
              columnProps: {
                label: '订单类型',
                prop: 'orderType',
              },
            },
            {
              name: 'returnType',
              columnProps: {
                label: '退车类型',
                prop: 'returnType',
              },
            },
            {
              name: 'state',
              columnProps: {
                label: '退车单状态',
                prop: 'state',
                width: 120,
              },
            },
            {
              name: 'returnTime',
              columnProps: {
                label: '预约退车时间',
                prop: 'bookTime',
                width: 150,
              },
              render: ({ row }) => {
                const timeStr =
                  row.bookTimeStart && row.bookTimeEnd
                    ? `${row.bookTimeStart}-${row.bookTimeEnd}`
                    : ''
                return <span>{timeStr || '--'}</span>
              },
            },
            {
              name: 'returnStartTime',
              columnProps: {
                label: '退车发起时间',
                prop: 'returnStartTime',
                width: 150,
              },
            },
            {
              name: 'operate',
              columnProps: {
                label: '操作',
                fixed: 'right',
                width: 240,
              },
              maxShowLength: operateMaxShowLength,
              getOperateList: ({ row }) => {
                const { id, orderId, orderType, state } = row
                const queryObj = {
                  id,
                  orderId,
                }
                const queryStr = encodeURIComponent(JSON.stringify(queryObj))

                const editBtnAction = () => {
                  if (orderType === ORDER_TYPES.personal.name) {
                    this.$router.push(`${PERSONAL_ADD_PATH}?query=${queryStr}`)
                  } else {
                    this.$router.push(
                      `${ENTERPRISE_ADD_PATH}?query=${queryStr}`,
                    )
                  }
                }

                const cancelBtnAction = () => {
                  this.$confirm('确认取消该条退车单？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                  })
                    .then(() => {
                      this.handleOrderCancel(row)
                    })
                    .catch(() => null)
                }

                // 退车预约单 取消操作
                const appointmentCancelBtnAction = () => {
                  this.$confirm('确认取消该条预约单？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                  })
                    .then(() => {
                      this.handleAppointmentCancel(row)
                    })
                    .catch(() => null)
                }

                // 已预约-发起退车
                const exitCarBtnAction = () => {
                  if (orderType === ORDER_TYPES.personal.name) {
                    this.$router.push(`${PERSONAL_ADD_PATH}?query=${queryStr}`)
                  } else {
                    this.$router.push(
                      `${ENTERPRISE_ADD_PATH}?query=${queryStr}`,
                    )
                  }
                }

                const checkoutCarBtn = this.judgePermission(
                  'return_lease_inspect',
                )
                  ? {
                    name: 'checkoutCar',
                    label: '退车验车',
                    action: editBtnAction,
                  }
                  : undefined

                const checkoutOrderBtn =
                  this.judgePermission('return_leas_account_add') ||
                  this.judgePermission('return_lease_account_submit')
                    ? {
                      name: 'checkoutOrder',
                      label:
                          row.settlementState === 4 ? '重新核算' : '订单核算',
                      action: editBtnAction,
                    }
                    : undefined

                const checkoutExpenseBtn = this.judgePermission(
                  'return_lease_settle',
                )
                  ? {
                    name: 'checkoutExpense',
                    label: '费用结算',
                    action: editBtnAction,
                  }
                  : undefined

                const cancelBtn = this.judgePermission('return_lease_cancel')
                  ? {
                    name: 'cancel',
                    label: '取消',
                    action: cancelBtnAction,
                  }
                  : undefined

                const appointmentCancelBtn = {
                  name: 'cancel',
                  label: '取消', // 这个是预约取消
                  action: appointmentCancelBtnAction,
                }

                const startExitCarBtn = this.judgePermission(
                  'return_lease_inspect',
                )
                  ? {
                    name: 'exitCar',
                    label: '发起退车',
                    action: exitCarBtnAction,
                  }
                  : undefined

                const checkoutCarWaitingBtns = [
                  checkoutCarBtn,
                  cancelBtn,
                ].filter((btn) => Boolean(btn))
                const checkoutOrderWaitingBtns = [checkoutOrderBtn].filter(
                  (btn) => Boolean(btn),
                )
                const checkoutExpenseBtns = [checkoutExpenseBtn].filter((btn) =>
                  Boolean(btn))
                const returnCarCompletedBtns = []
                const returnCarClosed = []
                const appointCancelOrExitCar = [
                  appointmentCancelBtn,
                  startExitCarBtn,
                ].filter((btn) => Boolean(btn))

                let optBtns = []

                if (state === RETURN_CAR_ORDER_STATES.checkoutCarWaiting.name) {
                  optBtns = checkoutCarWaitingBtns
                } else if (
                  state === RETURN_CAR_ORDER_STATES.checkoutOrderWaiting.name
                ) {
                  optBtns = checkoutOrderWaitingBtns
                } else if (
                  state === RETURN_CAR_ORDER_STATES.checkoutExpense.name
                ) {
                  optBtns = checkoutExpenseBtns
                } else if (
                  state === RETURN_CAR_ORDER_STATES.returnCarCompleted.name
                ) {
                  optBtns = returnCarCompletedBtns
                } else if (
                  state === RETURN_CAR_ORDER_STATES.returnCarClosed.name
                ) {
                  optBtns = returnCarClosed
                } else if (state === RETURN_CAR_ORDER_STATES.appointment.name) {
                  optBtns = appointCancelOrExitCar
                }

                return optBtns
              },
              type: 'operate',
            },
          ],
          pagination: {
            pageSizes: [10, 20, 30, 50],
          },
          apiFn: getReturnCarOrderList,
        },
      },
    }
  },
}
